<app-navbar/>
<div class="main-container">
  <div class="panel modern-card">
    <div class="panel-header modern-header">
      <h2>
        <i class="bi bi-building me-2"></i>
        Empresas
      </h2>
    </div>
    <div class="panel-body">
      <!-- Botão para alternar entre tabela e formulário -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h5 class="section-title">{{ showForm ? 'Cadastrar Empresa' : 'Empresas Cadastradas' }}</h5>
        <button class="btn btn-modern-primary btn-lg" (click)="toggleForm()"
               [disabled]="!isSuperAdministrador() && !showForm" 
               [title]="isSuperAdministrador() || showForm ? (showForm ? 'Voltar para listagem' : 'Adicionar nova empresa') : 'Somente SuperAdministrador pode adicionar empresas'">
          <i class="bi" [ngClass]="{'bi-plus-circle': !showForm, 'bi-arrow-left': showForm}"></i>
          {{ showForm ? 'Voltar' : '+ Empresa' }}
        </button>
      </div>

      <div *ngIf="mensagem != ''" class="alert-container animate__animated animate__fadeIn">
        <div class="alert alert-dismissible fade show" [ngClass]="{'alert-error': isError, 'alert-success': !isError}" role="alert">
          <i class="bi bi-exclamation-triangle-fill me-2" *ngIf="isError"></i>
          <i class="bi bi-check-circle-fill me-2" *ngIf="!isError"></i>
          <strong>{{ mensagem }}</strong>
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      </div>

      <!-- Formulário de cadastro -->
      <form *ngIf="showForm" [formGroup]="formulario" (ngSubmit)="onSubmit()" class="animate__animated animate__fadeIn modern-form">
        <div class="row g-4">
          <div class="col-md-6">
            <label for="nome" class="form-label fw-bold">Nome da Empresa</label>
            <input id="nome" type="text" class="form-control form-control-lg" placeholder="Digite o nome da empresa" formControlName="nome" />
            <div class="text-danger small" *ngIf="f['nome'].touched && f['nome'].invalid">
              Por favor, informe o nome da empresa.
            </div>
          </div>
    
          <div class="col-md-3">
            <label for="cep" class="form-label fw-bold">CEP</label>
            <input id="cep" type="text" class="form-control form-control-lg" placeholder="00000-000" formControlName="cep" mask="00000-000" (blur)="buscarCep()" />
            <div class="text-danger small" *ngIf="f['cep'].touched && f['cep'].invalid">
              {{ f['cep'].errors?.['invalidCep'] ? 'CEP não encontrado. Verifique o CEP informado.' : 'Por favor, informe um CEP válido (xxxxx-xxx).' }}
            </div>
          </div>
    
          <div class="col-md-3">
            <label for="numero" class="form-label fw-bold">Número</label>
            <input id="numero" type="text" class="form-control form-control-lg" placeholder="Digite o número" formControlName="numero" />
            <div class="text-danger small" *ngIf="f['numero'].touched && f['numero'].invalid">
              Por favor, informe o número do endereço.
            </div>
          </div>
    
          <div class="col-md-6">
            <label for="logradouro" class="form-label fw-bold">Logradouro</label>
            <input id="logradouro" type="text" class="form-control form-control-lg" placeholder="Digite o logradouro" formControlName="logradouro" />
            <div class="text-danger small" *ngIf="f['logradouro'].touched && f['logradouro'].invalid">
              Por favor, informe o logradouro.
            </div>
          </div>

          <div class="col-md-3">
            <label for="complemento" class="form-label fw-bold">Complemento</label>
            <input id="complemento" type="text" class="form-control form-control-lg" placeholder="Opcional" formControlName="complemento" />
          </div>

          <div class="col-md-3">
            <label for="bairro" class="form-label fw-bold">Bairro</label>
            <input id="bairro" type="text" class="form-control form-control-lg" placeholder="Digite o bairro" formControlName="bairro" />
            <div class="text-danger small" *ngIf="f['bairro'].touched && f['bairro'].invalid">
              Por favor, informe o bairro.
            </div>
          </div>
          
          <div class="col-md-4">
            <label for="cidade" class="form-label fw-bold">Cidade</label>
            <input id="cidade" type="text" class="form-control form-control-lg" placeholder="Digite a cidade" formControlName="cidade" />
            <div class="text-danger small" *ngIf="f['cidade'].touched && f['cidade'].invalid">
              Por favor, informe a cidade.
            </div>
          </div>
          
          <div class="col-md-2">
            <label for="uf" class="form-label fw-bold">UF</label>
            <input id="uf" type="text" class="form-control form-control-lg" placeholder="UF" formControlName="estado" readonly />
            <div class="text-danger small" *ngIf="f['estado'].touched && f['estado'].invalid">
              Por favor, informe a UF.
            </div>
          </div>

        </div>
        <div class="mt-4">
          <button type="submit" class="btn btn-success btn-lg w-100" [disabled]="formulario.invalid">
            <i class="bi" [ngClass]="{'bi-plus-circle': !editando, 'bi-check-circle': editando}"></i>
            {{ editando ? 'Atualizar Empresa' : 'Cadastrar Empresa' }}
          </button>
        </div>
      </form>

      <!-- Tabela de consulta -->
      <div *ngIf="!showForm" class="animate__animated animate__fadeIn">
        <!-- Filtros -->
        <div class="filtro-form modern-form mb-4">
          <div class="filter-container">
            <div class="form-group">
              <label for="searchTerm">
                <i class="bi bi-search me-1"></i> Pesquisar
              </label>
              <input type="text" class="form-control search-input" placeholder="Digite para pesquisar..." 
                    [(ngModel)]="searchTerm" (ngModelChange)="onSearch()">
            </div>
            <div class="form-group">
              <label for="itemsPerPage">
                <i class="bi bi-list-ul me-1"></i> Itens por página
              </label>
              <select id="itemsPerPage" class="form-select form-select-sm" [(ngModel)]="itemsPerPage" (ngModelChange)="onItemsPerPageChange()">
                <option value="5">5 itens</option>
                <option value="10">10 itens</option>
                <option value="20">20 itens</option>
                <option value="50">50 itens</option>
              </select>
            </div>
            <div class="form-buttons">
              <button class="btn btn-secondary" (click)="searchTerm = ''; onSearch()">
                <i class="bi bi-x-circle me-1"></i> Limpar
              </button>
            </div>
          </div>
        </div>
        
        <!-- Loading state -->
        <div *ngIf="paginatedClientes.length === 0 && searchTerm" class="modern-empty">
          <i class="bi bi-info-circle"></i>
          <p>Nenhuma empresa encontrada com os filtros aplicados.</p>
        </div>

        <div class="table-container modern-table-container">
          <table class="table modern-table">
            <thead>
              <tr>
                <th scope="col" class="sortable" (click)="sortBy('nome')">
                  <span class="th-icon-label">
                    Nome <i class="bi" [ngClass]="getSortIcon('nome')"></i>
                  </span>
                </th>
                <th scope="col" class="sortable" (click)="sortBy('cidade')">
                  <span class="th-icon-label">
                    Cidade <i class="bi" [ngClass]="getSortIcon('cidade')"></i>
                  </span>
                </th>
                <th scope="col" class="sortable" (click)="sortBy('uf')">
                  <span class="th-icon-label">
                    UF <i class="bi" [ngClass]="getSortIcon('uf')"></i>
                  </span>
                </th>
                <th scope="col">
                  <span class="th-icon-label">
                    Endereço
                  </span>
                </th>
                <th scope="col">
                  <span class="th-icon-label">
                    Ações
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let empresa of paginatedClientes" class="animate__animated animate__fadeIn">
                <td class="font-weight-medium">{{ empresa.nome }}</td>
                <td>{{ empresa.cidade }}</td>
                <td class="text-center">
                  <span class="badge badge-uf">{{ empresa.uf }}</span>
                </td>
                <td>
                  <span class="endereco-tooltip" [title]="empresa.endereco">
                    {{ empresa.endereco | slice:0:50 }}{{ empresa.endereco.length > 50 ? '...' : '' }}
                  </span>
                </td>
                <td>
                  <div class="btn-group action-buttons">
                    <button class="btn btn-sm btn-primary btn-action" (click)="editarEmpresa(empresa); toggleForm()" 
                      [disabled]="role === 'Visitante'" 
                      [title]="role === 'Visitante' ? 'Visitantes não podem editar empresas' : 'Editar'">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    <button class="btn btn-sm btn-danger btn-action" (click)="excluirEmpresa(empresa.empresaId)" 
                      [disabled]="!isSuperAdministrador()" 
                      [title]="isSuperAdministrador() ? 'Excluir' : 'Somente SuperAdministrador pode excluir empresas'">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr *ngIf="paginatedClientes.length === 0 && !searchTerm">
                <td colspan="5" class="text-center empty-state">
                  <i class="bi bi-inbox-fill"></i>
                  <p>Nenhuma empresa cadastrada</p>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="table-footer">
            <div class="showing-entries">
              Mostrando {{ getPaginationInfo().start }} a {{ getPaginationInfo().end }} de {{ empresas.length }} registros
            </div>
            <nav aria-label="Page navigation" class="pagination-wrapper">
              <ul class="pagination">
                <li class="page-item" [class.disabled]="currentPage === 1">
                  <a class="page-link" (click)="previousPage()" aria-label="Previous">
                    <i class="bi bi-chevron-left"></i>
                  </a>
                </li>
                <li class="page-item" *ngFor="let page of getVisiblePages()" [class.active]="currentPage === page">
                  <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
                </li>
                <li class="page-item" [class.disabled]="currentPage === totalPages">
                  <a class="page-link" (click)="nextPage()" aria-label="Next">
                    <i class="bi bi-chevron-right"></i>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>